import { AxiosResponse } from 'axios';
import { getData, postData, delData } from '../../../utils/fetch-api-util';
import { API_URLS } from '../../../constants/urls/api-urls';

export interface CreateTextPayload {
  keyText: string;
  value: string;
}
export interface UpdateTextPayload {
  id: string;
  keyText: string;
  value?: string;
}
export enum KeyText {
  US_SUB_PRODUCT_CATALOG = 'US_SUB_PRODUCT_CATALOG',
  CA_SUB_PRODUCT_CATALOG = 'CA_SUB_PRODUCT_CATALOG',
  US_PRODUCT_CATALOG = 'US_PRODUCT_CATALOG',
  CA_PRODUCT_CATALOG = 'CA_PRODUCT_CATALOG',
}

export const getTextsRepository = async (): Promise<any[]> => {
  const response = await getData<{}, []>(API_URLS.TEXT_LIST_API);
  return response.data;
};

export const saveTextRepository = (data: CreateTextPayload): Promise<AxiosResponse<any>> => {
  return postData(API_URLS.TEXT_CREATE_API, data);
};

export const updateTextRepository = (payload: UpdateTextPayload): Promise<AxiosResponse<any>> => {
  return postData(API_URLS.TEXT_UPDATE_API, payload);
};

export const deleteTextRepository = (TextId: string): Promise<AxiosResponse<any>> => {
  return delData(API_URLS.TEXT_DELETE_API(TextId));
};
